import type { InstitutionKey } from "@design-system/InstitutionIcon/InstitutionIcon";
import { getConnectorInstitutionForClientName } from "@components/settings/McpCli/connectorDefinitions";

export function getClientInstitution(
    clientName: string | null,
): InstitutionKey {
    return getConnectorInstitutionForClientName(clientName);
}

/**
 * Always echoes the name the client registered with. A curated connector name
 * must never stand in for it here, otherwise a client whose name merely
 * mentions a known brand would be presented as that brand on the consent
 * screen.
 */
export function getClientDisplayName(clientName: string | null): string {
    const trimmed = clientName?.trim();
    if (!trimmed) {
        return "An MCP client";
    }
    return trimmed.charAt(0).toUpperCase() + trimmed.slice(1);
}
